var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row"data-bind="visibleAnimated: Module() === \'Success\'"style="display:none"> <div class="col-md-12"> <p>Спасибо, заявка на оформление полиса успешно отправлена!</p> <p>Наш оператор свяжется с Вами в ближайшее время и расскажет о&nbsp;дальнейших действиях.</p> </div> </div>';
}
return __p;
};
